// useGoogleMapsLoader.js
import { useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

// Define the libraries array as a constant outside the component
const LIBRARIES = ['places'];

const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const { isLoaded: googleMapsLoaded } = useJsApiLoader({
    version: 'single-map',
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAmcGjLChegfkj9yJZBMKhlk18ckavo3HI',
    // googleMapsApiKey: 'AIzaSyB0gR2rR1HnQsNLD17K5CioVDYCqKk-KQk',
    libraries: LIBRARIES,
  });

  useEffect(() => {
    if (googleMapsLoaded) {
      setIsLoaded(true);
    }
  }, [googleMapsLoaded]);

  return isLoaded;
};

export default useGoogleMaps;